import { UIBetSettingsType, UIDenomDisplayType, UIElements, UISettingsButtons } from "gameiom/wrapper/wrapper-data";
import { Jurisdiction } from "slotworks/services/jurisdiction/jurisdiction-service";

export enum JackpotTiers {
    GRAND,
    MAJOR
}

export const JackpotTierKeys = new Map<string, JackpotTiers>([
    ["major", JackpotTiers.MAJOR],
    ["grand", JackpotTiers.GRAND]
]);

export const JackpotTierNames = new Map<JackpotTiers, string>([
    [JackpotTiers.MAJOR, "major"],
    [JackpotTiers.GRAND, "grand"]
]);

class GameiomModel {
    public url: string;
    public sessionToken: string;
    public username: string;
    public rtp: string;
    public providerId: number;
    public operatorId: number;
    public gameId: number;
    public language: string;
    public currency: string;
    public callbackUrl: string;
    public jurisdiction: string;
    public displayCurrency: boolean;
    public disableSpinSkip: boolean;
    public enableForcing: boolean;
    public displayMaxBet: boolean;
    public displayClock: boolean;
    public denomDisplay: string = UIDenomDisplayType.denom;
    public betSettings: string = UIBetSettingsType.totalBet;
    public hideBalance: boolean = false;
    public hideBet: boolean = true;
    public hideDenom: boolean = true;
    public hideJackpotWording: boolean;
    public jackpotAmounts: Map<JackpotTiers, number>;
    public removeFromCurrencyString: string;
    public displayWholeStakeAsDecimal: boolean = true;
    public wholeNumberCurrencies: string[];
    public disableSpaceToSpin: boolean;
    public displayType: string;
    public stopOnFeatureWin: boolean;
    public hideEnableSoundsPrompt: boolean;
    public displayStopOnFeatureButton: boolean;
    public autoplayStopOnFeatureOverideSet: boolean;
    public preSelectAutoplayOptions: boolean = true;
    public enabledSettingsButtons: string[] = [];
    public slamStop: boolean;
    public isSocial: boolean = false;
    public prizeTable: number[];
    public paylines: number[][];
    public paytable: number[][];

    public displayButtons: Map<UIElements, boolean> = new Map<UIElements, boolean>([
        [UIElements.homeButton, true],
        [UIElements.depositPageButton, false],
        [UIElements.accountsButton, false]
    ] as any);

    protected readonly minimumNumSettingsOptions = 2;

    public shouldDisplayCurrencyAsWholeNumber() {
        return (
            gameiomModel.wholeNumberCurrencies != null &&
            gameiomModel.wholeNumberCurrencies.find((currency) => currency === gameiomModel.currency) != null
        );
    }

    public shouldDisplayCredits() {
        return !this.displayCurrency || this.isSocial;
    }

    public shouldDisplaySettingsButton() {
        return this.enabledSettingsButtons.length >= this.minimumNumSettingsOptions;
    }
}

export const gameiomModel = new GameiomModel();
